<template>
    <div class="wrap">
        <listHeader
            :back="true"
            :title="postData.cbid > 0 ? '编辑班级' : '新增班级'"
        ></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="class"
                active="info"
                :cbid="postData.cbid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="班级类型"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    placeholder="选择班级类型"
                                    v-decorator="['type', {required: true, rules: [{ message: '选择班级类型' }]}]">
                                    <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">
                                        {{ item }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="班级名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入班级名称" v-decorator="['cname', {rules: [{ required: true, max: 64, message: '请输入班级名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="专业"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    placeholder="选择专业"
                                    v-decorator="['maid', {rules: [{ required: true, message: '选择专业' }]}]">
                                    <a-select-option v-for="item in config.major" :key="item.maid" :value="item.maid">
                                        {{ item.prefix }}{{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="就业专员"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    placeholder="选择招聘经理"
                                    v-decorator="['mid', {rules: [{ required: true, message: '选择招聘经理' }]}]">
                                    <template v-for="(item, key) in config.manager">
                                        <a-select-option :key="key" :value="item[0]" v-if="item[0].charAt(0) != 'G'">
                                            {{ item[1] }}
                                        </a-select-option>
                                        <a-select-option v-else :key="key" :value="item[0]" :disabled="true">
                                            {{ item[1] }}
                                        </a-select-option>
                                    </template>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="教员"
                                v-bind="formItemLayout"
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    v-decorator="['tid_jy', {rules: [{ message: '选择教员' }], initialValue: '0'}]"
                                >
                                    <a-select-option value="0">选择教员</a-select-option>
                                    <a-select-option v-for="item in config.teacher" :key="item.tid" :value="item.tid">
                                        {{ item.tname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="班主任"
                                v-bind="formItemLayout"
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    v-decorator="['tid_bzr', {rules: [{ message: '选择班主任' }], initialValue: '0'}]"
                                >
                                    <a-select-option value="0">选择班主任</a-select-option>
                                    <a-select-option v-for="item in config.teacher" :key="item.tid" :value="item.tid">
                                        {{ item.tname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="学校"
                                v-bind="formItemLayout"
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    v-decorator="['sid', {rules: [{ message: '选择学校' }], initialValue: '0'}]"
                                    @change="school"
                                >
                                    <a-select-option value="0">选择学校</a-select-option>
                                    <a-select-option v-for="item in config.school" :key="item.sid" :value="item.sid">
                                        {{ item.sname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="学院"
                                v-bind="formItemLayout"
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    v-decorator="['scid', {rules: [{ message: '选择学院' }], initialValue: '0'}]"
                                >
                                    <a-select-option value="0">选择学院</a-select-option>
                                    <a-select-option v-for="item in college" :key="item.scid" :value="item.scid">
                                        {{ item.scname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="企业"
                                v-bind="formItemLayout"
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    v-decorator="['eid', {rules: [{ message: '选择企业' }], initialValue: '0'}]"
                                >
                                    <a-select-option value="0">选择企业</a-select-option>
                                    <a-select-option v-for="item in config.enterprise" :key="item.eid" :value="item.eid">
                                        {{ item.ename }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="开班日期"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择开班日期"
                                    v-decorator="['starttime',{rules: [{ required: false, message: '请选择开班日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="结业日期"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择结业日期"
                                    v-decorator="['endtime',{rules: [{ required: false, message: '请选择结业日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="结算日期"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择结算日期"
                                    v-decorator="['finishtime',{rules: [{ required: false, message: '请选择结算日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="班级状态"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    placeholder="请选择班级状态"
                                    v-decorator="['status',{rules: [{ required: true, message: '请选择班级状态' }]} ]">
                                    <a-select-option v-for="(item, key) in config.status" :key="key" :value="key">
                                        {{ item }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="课程"
                                v-bind="formItemLayout"
                                required
                                v-if="postData.cbid == ''"
                            >
                                <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    placeholder="请选择班级课程"
                                    v-decorator="['lid',{rules: [{ required: true, message: '请选择班级课程' }]} ]">
                                    <a-select-option v-for="(item, key) in config.lesson" :key="item.lid" :value="item.lid">
                                        {{ item.lname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import moment from "moment";
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab
    },
    data() {
        return {
            scenario: 'classCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'cbid': '',
            },
            data: {},
            config: {},
            college: {},
            dateFormat: 'YYYY-MM-DD',
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/class/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;
                this.college = this.config.college;

                if (res.data.cbid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            type: res.data.type,
                            cname: res.data.cname,
                            maid: res.data.maid,
                            mid: res.data.muid,
                            tid_jy: res.data.tid_jy ? res.data.tid_jy : null,
                            tid_bzr: res.data.tid_bzr ? res.data.tid_bzr : null,
                            sid: res.data.sid ? res.data.sid : null,
                            scid: res.data.scid ? res.data.scid: null,
                            eid: res.data.eid ? res.data.eid : null,
                            starttime: res.data.starttime != '0' ? moment(res.data.starttime_str, this.dateFormat) : null,
                            endtime: res.data.endtime != '0' ? moment(res.data.endtime_str, this.dateFormat) : null,
                            finishtime: res.data.finishtime != '0' ? moment(res.data.finishtime_str, this.dateFormat) : null,
                            status: res.data.status,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.cbid > 0) {
                            url = '/manage/class/edit';
                            values.cbid = this.postData.cbid;
                        } else {
                            url = '/manage/class/save';
                        }

                        values.starttime = values.starttime ? values.starttime.format(this.dateFormat) : '';
                        values.endtime = values.endtime ? values.endtime.format(this.dateFormat) : '';
                        values.finishtime = values.finishtime ? values.finishtime.format(this.dateFormat) : '';

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.cbid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
        school(e) {
            // init
            this.form.setFieldsValue({
                scid: '0',
            });

            if (e == '') {
                this.config.college = [];
            }

            // 参数
            let param = {
                sid: e
            };

            // 查询数据
            this.http('/manage/college/list', param, (res) => {
                let college = [];
                for (let i in res.list.data) {
                    college[i] = {
                        scid: res.list.data[i].scid.toString(),
                        scname: res.list.data[i].scname,
                    };
                }
                this.college = college;
            }, null, 2);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
